import { Ticket, Sorteo, TipoSorteo, NumeroRestringido, Modalidad, NumeroGanador, ListaNumeros, SorteoEstado } from '../types';
import { fechaLocalYMD } from '../utils/date';

// Sorteos del día mock
export const mockSorteos: Sorteo[] = [
  {
    id: 'S001',
    nombre: 'Diaria 11:00',
    modalidad: 'DIARIA',
    hora: '11:00',
    activo: true,
    fecha: new Date('2026-02-03'),
    tipoSorteoId: 'TS001',
    estado: 'FINALIZADO',
  },
  {
    id: 'S002',
    nombre: 'Diaria 15:00',
    modalidad: 'DIARIA',
    hora: '15:00',
    activo: true,
    fecha: new Date('2026-02-03'),
    tipoSorteoId: 'TS001',
    estado: 'CERRADO',
  },
  {
    id: 'S003',
    nombre: 'Diaria 21:00',
    modalidad: 'DIARIA',
    hora: '21:00',
    activo: true,
    fecha: new Date('2026-02-03'),
    tipoSorteoId: 'TS001',
    estado: 'ABIERTO',
  },
  {
    id: 'S004',
    nombre: 'Tica 20:00',
    modalidad: 'TICA',
    hora: '20:00',
    activo: true,
    fecha: new Date('2026-02-03'),
    tipoSorteoId: 'TS002',
    estado: 'ABIERTO',
  },
  {
    id: 'S005',
    nombre: 'Chances 13:00',
    modalidad: 'CHANCES',
    hora: '13:00',
    activo: true,
    fecha: new Date('2026-02-03'),
    tipoSorteoId: 'TS003',
    estado: 'ABIERTO',
  },
];

// Tipos de sorteo mock
export const mockTiposSorteo: TipoSorteo[] = [
  {
    id: 'TS001',
    nombre: 'Lotería Diaria',
    modalidad: 'DIARIA',
    descripcion: 'Sorteo diario 3 veces al día',
    activo: true,
  },
  {
    id: 'TS002',
    nombre: 'Lotería Tica',
    modalidad: 'TICA',
    descripcion: 'Sorteo nacional nocturno',
    activo: true,
  },
  {
    id: 'TS003',
    nombre: 'Chances',
    modalidad: 'CHANCES',
    descripcion: 'Chances de mediodía',
    activo: true,
  },
  {
    id: 'TS004',
    nombre: 'Monazos',
    modalidad: 'MONAZOS',
    descripcion: 'Sorteo especial de fin de semana',
    activo: true,
  },
];

// Tickets vendidos mock
export const mockTickets: Ticket[] = [
  {
    id: 'TK001',
    codigo: 'TK-2026-0125',
    lineas: [
      { id: 'L1', modalidad: 'DIARIA', numero: '25', monto: 500 },
      { id: 'L2', modalidad: 'DIARIA', numero: '77', monto: 1000 },
      { id: 'L3', modalidad: 'TICA', numero: '42', monto: 500 },
    ],
    total: 2000,
    metodoPago: 'EFECTIVO',
    esCredito: false,
    fecha: new Date('2026-02-03T09:30:00'),
    estado: 'VENDIDO',
    vendedorId: '4',
  },
  {
    id: 'TK002',
    codigo: 'TK-2026-0126',
    lineas: [
      { id: 'L1', modalidad: 'DIARIA', numero: '13', monto: 2000 },
      { id: 'L2', modalidad: 'CHANCES', numero: '88', monto: 1500 },
    ],
    total: 3500,
    metodoPago: 'CREDITO',
    clienteId: 'C002',
    clienteNombre: 'Ana García',
    referencia: 'Paga el viernes',
    esCredito: true,
    fecha: new Date('2026-02-03T10:15:00'),
    estado: 'VENDIDO',
    vendedorId: '4',
  },
  {
    id: 'TK003',
    codigo: 'TK-2026-0127',
    lineas: [
      { id: 'L1', modalidad: 'TICA', numero: '00', monto: 5000 },
    ],
    total: 5000,
    metodoPago: 'SINPE',
    esCredito: false,
    fecha: new Date('2026-02-03T11:00:00'),
    estado: 'VENDIDO',
    vendedorId: '4',
  },
  {
    id: 'TK004',
    codigo: 'TK-2026-0128',
    lineas: [
      { id: 'L1', modalidad: 'DIARIA', numero: '99', monto: 1000 },
      { id: 'L2', modalidad: 'DIARIA', numero: '01', monto: 1000 },
      { id: 'L3', modalidad: 'DIARIA', numero: '50', monto: 500 },
    ],
    total: 2500,
    metodoPago: 'CREDITO',
    clienteId: 'C001',
    clienteNombre: 'Juan Pérez',
    referencia: 'Semanal',
    esCredito: true,
    fecha: new Date('2026-02-03T11:30:00'),
    estado: 'VENDIDO',
    vendedorId: '4',
  },
];

// Números restringidos mock
export const mockNumerosRestringidos: NumeroRestringido[] = [
  {
    id: 'NR001',
    numero: '00',
    modalidad: 'DIARIA',
    sorteoId: 'S001',
    limiteVenta: 50000,
    ventaActual: 45000,
  },
  {
    id: 'NR002',
    numero: '25',
    modalidad: 'DIARIA',
    sorteoId: 'S001',
    limiteVenta: 30000,
    ventaActual: 28500,
  },
  {
    id: 'NR003',
    numero: '13',
    modalidad: 'TICA',
    sorteoId: 'S004',
    limiteVenta: 25000,
    ventaActual: 12000,
  },
];

// Modalidades disponibles
export const modalidades: { value: Modalidad; label: string; color: string }[] = [
  { value: 'DIARIA', label: 'Diaria', color: 'bg-blue-500' },
  { value: 'TICA', label: 'Tica', color: 'bg-green-500' },
  { value: 'CHANCES', label: 'Chances', color: 'bg-purple-500' },
  { value: 'MONAZOS', label: 'Monazos', color: 'bg-orange-500' },
  { value: 'LOTTO', label: 'Lotto', color: 'bg-red-500' },
];

// Números ganadores mock
export const mockNumerosGanadores: NumeroGanador[] = [
  {
    id: 'NG001',
    numero: '25',
    tipoSorteoId: 'TS001',
    fecha: fechaLocalYMD(),
    horaSorteo: '11:00',
    totalPremios: 125000,
    cantidadGanadores: 5,
    verificado: true,
    registradoPor: 'Admin Banca',
    horaRegistro: '11:05',
  },
  {
    id: 'NG002',
    numero: '77',
    tipoSorteoId: 'TS001',
    fecha: fechaLocalYMD(),
    horaSorteo: '15:00',
    totalPremios: 89000,
    cantidadGanadores: 3,
    verificado: true,
    registradoPor: 'Admin Banca',
    horaRegistro: '15:05',
  },
  {
    id: 'NG003',
    numero: '13',
    tipoSorteoId: 'TS002',
    fecha: fechaLocalYMD(),
    horaSorteo: '20:00',
    totalPremios: 245000,
    cantidadGanadores: 8,
    verificado: false,
    registradoPor: 'Admin Banca',
    horaRegistro: '20:05',
  },
];

// Listas de números mock
export const mockListasNumeros: ListaNumeros[] = [
  {
    id: 'LN001',
    nombre: 'Números Calientes',
    descripcion: 'Los números más vendidos este mes',
    tipo: 'FAVORITOS',
    tipoSorteoId: 'TS001',
    numeros: ['00', '07', '13', '21', '25', '33', '42', '50', '77', '99'],
    activa: true,
  },
  {
    id: 'LN002',
    nombre: 'Bloqueados Riesgo',
    descripcion: 'Números con alta exposición',
    tipo: 'BLOQUEADOS',
    tipoSorteoId: 'TS001',
    numeros: ['00', '25'],
    activa: true,
  },
  {
    id: 'LN003',
    nombre: 'Terminados en 7',
    descripcion: 'Números terminados en 7',
    tipo: 'PERSONALIZADA',
    tipoSorteoId: '',
    numeros: ['07', '17', '27', '37', '47', '57', '67', '77', '87', '97'],
    activa: true,
  },
];

// Generar código de ticket
export const generateTicketCode = (): string => {
  const year = new Date().getFullYear();
  const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
  return `TK-${year}-${random}`;
};
